// src/store/generalReducer.ts

import { combineReducers } from 'redux';
import networkInformationsReducer from './networkManagment/reducer';
import userListReducer            from './userManagment/reducer';
import mediaListReducer           from './mediaManagment/reducer';
import paymentListReducer         from './paymentManagment/reducer';
import booleanMapReducer          from './demoManagment/reducer';
import mediaCategoryReducer       from './mediaCategoryManagment/reducer';
import thirdPartyStreamingReducer from './thirdPartyStreamingSystemManagment/reducer';
import authenticationReducer      from './adminAuthenticationManagment/reducer';
import clientReducer              from './clientManagment/reducer';
import fileUploadReducer          from './fileManagment/reducer';
import productListReducer         from './productManagment/reducer';
import productCategoryReducer     from './productCategoryManagment/reducer';
import tasksReducer               from './tasksManagment/reducer';
import purchaseModalReducer       from './purchaseModalManagment/reducer';
import tierPickerReducer          from './tierPickerManagment/reducer';
import subscriptionPurchaseModalReducer from './subscriptionPurchaseModalManagment/reducer';

const reducers = combineReducers({
  networkInformationsReducer,
  userListReducer,
  mediaListReducer,
  paymentListReducer,
  booleanMapReducer,
  mediaCategoryReducer,
  thirdPartyStreamingReducer,
  authenticationReducer,
  clientReducer,
  fileUploadReducer,
  productListReducer,
  productCategoryReducer,
  tasksReducer,
  purchaseModalReducer,
  tierPickerReducer,
  subscriptionPurchaseModalReducer,
});

export type RootState = ReturnType<typeof reducers>;
export default reducers;